import { type PendingAdhocDistributionSummary } from '../../api-schema-types/asset-holdings/AdhocDistributionCrudDtos'

 
export function adhocDistributionApiMapper () {
  const pendingAdhocDistributionSummaryMapper = (
    responseData: PendingAdhocDistributionSummary,
    responseMeta: any,
    responseArgs: any
  ): PendingAdhocDistributionSummary => {
    return responseData
  }

  return {
    pendingAdhocDistributionSummaryMapper
  }
}
